import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import Deatils from './components/details';
import Sheet from './components/sheet';
export default {
  name: "statistics-cost",
  data: function data() {
    return {
      currentTableData: [{}],
      loading: false,
      searchKey: '',
      template: null
    };
  },
  methods: {
    view: function view() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$_this$$awaitTo, _yield$_this$$awaitTo2, err, data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _this.$awaitTo(_this.$dialog(Deatils, {
                dialog: {
                  title: '明细'
                },
                props: {}
              }, function (template) {
                _this.template = template;
              }));
            case 1:
              _yield$_this$$awaitTo = _context.v;
              _yield$_this$$awaitTo2 = _slicedToArray(_yield$_this$$awaitTo, 2);
              err = _yield$_this$$awaitTo2[0];
              data = _yield$_this$$awaitTo2[1];
              _this.template = null;
              if (!err) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    sheet: function sheet() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _yield$_this2$$awaitT, _yield$_this2$$awaitT2, err, data;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$awaitTo(_this2.$dialog(Sheet, {
                dialog: {
                  title: '面单明细',
                  width: '1000px'
                },
                props: {}
              }, function (template) {
                _this2.template = template;
              }));
            case 1:
              _yield$_this2$$awaitT = _context2.v;
              _yield$_this2$$awaitT2 = _slicedToArray(_yield$_this2$$awaitT, 2);
              err = _yield$_this2$$awaitT2[0];
              data = _yield$_this2$$awaitT2[1];
              _this2.template = null;
              if (!err) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2);
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    }
  }
};